import React, { useContext, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'reactstrap';
import { useHistory } from "react-router-dom";
// import LanguageToggle from 'views/Forms/Private/LanguageToggle';
import {
  Button,
  Row,
  Col,
  FormGroup, FormControl, FormLabel
} from "react-bootstrap";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SweetAlert from "react-bootstrap-sweetalert";
import baolin_art2 from '../../../assets/img/baolinPrivate/baolin_art2.png';
import baolin_art3 from '../../../assets/img/baolinPrivate/baolin_art3.png';
import lianghuang from '../../../assets/img/baolinPrivate/lianghuang.png';
import vegefest from '../../../assets/img/baolinPrivate/vege_fest_poster.png';
import qingming1 from '../../../assets/img/baolinPrivate/qingming1.png';
import { GuestContext } from "../../../contexts/GuestContext";

function SliderArrowNext(props) {
  const { className, onClick } = props;


  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  );
}

function SliderArrowPrev(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  );
}


export default function LivePreviewExample() {
  const history = useHistory();
  const [alert, setAlert] = React.useState(null);
  const { language, setPageBanner } = useContext(GuestContext);
  useEffect(() => {
    setPageBanner(2);
  }, [setPageBanner]); // Dependencies array

  const handleRegisterClick = () => {
    history.push('/chingmingregister');
  };

  const slide1 = (<>
    <div>
      <a
        href="#/"
        onClick={(e) => e.preventDefault()}
        className="card m-3 shadow-sm-dark card-box-hover-rise">
        <img src={qingming1} className="card-img-center" alt="..." />
        <div className="p-3 .bg-white-5 rounded-bottom p-xl-4">
          <div className="flex-column flex-sm-row justify-content-between block">
            <div style={{ display: 'flex', alignItems: 'center',justifyContent: 'space-between' }}>
              <h5 className="font-weight-bold font-size-lg text-second mb-0 ">
                {language === "Chinese" ? "清明法会" : "Ching Ming Earth Stone Bodhisattva Ceremony"}
              </h5>
              {/* <Badge
                className="text-white"
                style={{
                  fontSize: '0.9em',
                  background: 'linear-gradient(45deg, darkred, darkorange, darkgoldenrod, darkgreen, darkblue, indigo, purple)',
                  backgroundSize: '200% 200%',
                  animation: 'gradientShift 2s linear infinite',
                  transform: 'rotate(10deg)',
                }}
              >
                  {language === "Chinese" ? "免費活動" : "Free Activities"}
              </Badge> */}
            </div>

            <h6 className="font-weight-bold font-size-lg text-second mb-1 mt-1 block">
              {/* {language === "Chinese" ? "12月21日" : "21/12/2024"} */}
            </h6>
          </div>
          <div>
            <Badge className="mr-1 text-white block" color="info" style={{ fontSize: '0.9em' }}>
              <div dangerouslySetInnerHTML={{ __html: language === "Chinese" ? "日期： 2025年3月30日" : `Date: Mar 30<sup>st</sup> 2025` }} />

            </Badge>
          </div>
          <Badge className="mr-1 text-white block" color="success" style={{ fontSize: '0.9em' }}>
            {language === "Chinese" ? "時間：上午 09:30 ～ 下午 4:30" : "Time: 09:30AM ～ 04:30PM"}
          </Badge>

          <p className="text-second opacity-8 mt-4 mb-4">
            <p className="text-second opacity-8 mt-4 mb-4">
              <p className="text-second opacity-8 mt-4 mb-4">
                {language === "Chinese" ? (
                  <>
                    <p className='font-weight-bold mb-3'>
                    寶林禪寺將舉辦「清明地藏消災超薦法會」，以弘揚佛法孝道文化及慎終追遠精神，藉由恭誦《地藏菩薩本願經》，功德回向，世界和平、歷代先亡及一切幽魂往生淨土。
有意參加法會或登記隨喜消災、超薦牌位者，請於3月30日前完成登記報名。

                    </p>
                  </>
                ) : (
                  <>
                    <p className='font-weight-bold mb-3'>
                    The Ching Ming (Ancestral Memorial) Ceremony offers an opportunity to honor ancestors and dedicate blessings. Participants will recite the Sutra of Original Vows of Bodhisattva Ksitigarbha, dedicating merits to deceased family members, ancestors, and all beings. You are also welcome to register tablets for family or friends, whether living or deceased. Tablets registration closes on March 30.
                    </p>
                  </>
                )}

              </p>

            </p>

          </p>

          <Row>
            <Col>
              <Button
                className="btn-round btn-wd mr-1 "
                style={{ fontWeight: 'bold' }}
                href="#/"
                type="button"
                variant="success"
                size="md"
                outline
                block
                onClick={handleRegisterClick}
              >
                {language === "Chinese" ? "我要報名" : "Register"}
              </Button>
            </Col>
          </Row>
        </div>
      </a>

    </div>
  </>)

  const slides = [slide1]

  const widgetsCarousels4A = {
    dots: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    infinite: slides.length >= 2,
    responsive: [
      {
        breakpoint: 1450,
        settings: { slidesToShow: 3, slidesToScroll: 1 }
      },
      {
        breakpoint: 1100,
        settings: { slidesToShow: 2, slidesToScroll: 1 }
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      }
    ]
  };


  return (
    <>
      {/* <Card className="bg-night-sky py-4"> */}
      <div className="py-0">
        <Slider
          className="rounded-lg overflow-hidden slider-arrows-outside slider-dots-outside slider-dots-light"
          {...widgetsCarousels4A}>
          {slides[0]}
        </Slider>
      </div>
      {/* </Card> */}
      {alert}
    </>
  );
}
